export function getBlobFilename(file) {
    if (!file || typeof file !== 'object') {
        return undefined;
    }
    const FileConstructor = Reflect.get(globalThis, 'File');
    if (typeof FileConstructor === 'function' &&
        file instanceof FileConstructor &&
        'name' in file &&
        typeof file.name === 'string' &&
        file.name.length > 0) {
        return file.name;
    }
    return undefined;
}
